import { FC, useEffect, useState } from 'react';
import { MessageBox } from 'ui/components/MessageBox';
import { PageWrapper } from 'ui/components/PageWrapper';
import heroSkewed from 'static/assets/img/hero_skewed.png';
import { getCheckIcon, getHourGlassIcon } from 'static/assets/icons';
import { demoState, userAnswer } from 'apis/general';
import { TabMenuProps } from 'ui/components/TabMenu';
import { useIonRouter } from '@ionic/react';
import { ERoutes } from 'static/data/ERoutes';
import { GameSlider } from 'ui/components/GameSlider';

/** Renders all the main content for the main demo app, based on the demo-state of the database.
 * 0: Not opened
 * 1: Opened    | 2: Closing soon   | 3: Closed     | 4: Studio revealed
 * 5: Correct answer revealed   | 6: DK + winner revealed   | 7: Awaiting next round
 * 8: Finished
 */
export const IngamePage: FC = () => {
  const router = useIonRouter();
  const [userInput, setUserInput] = useState(200);

  const getMenuPropsForDemoState = (): TabMenuProps => {
    if (demoState.value < 3 && userAnswer.value < 0) {
      return {
        mainButtonText: '',
        icon: getCheckIcon(),
        mainButtonClass: 'bg-success border-white animate-bounce',
        onMainClick: () => (userAnswer.value = userInput),
      };
    }
    return {
      icon: getHourGlassIcon(),
      mainButtonText: 'Afventer',
    };
  };

  useEffect(() => {
    if (demoState.value < 1) router.push(ERoutes.WELCOME, 'root');
    if (demoState.value > 7) router.push(ERoutes.LEADERBOARD, 'root');
  }, [demoState.value]);

  return (
    <PageWrapper className="!pt-[225px]" menuProps={getMenuPropsForDemoState()}>
      <div className="absolute top-0 left-0 w-full">
        <img src={heroSkewed} alt="Vært" className="w-full h-[190px] object-cover" />
        <div className="bg-primary h-8 w-[105%] ml-[-10px] mt-[-9px] -rotate-[2.5deg] flex flex-col justify-center">
          <h6 className="w-full text-right pr-6 tracking-wider font-semibold">{demoState.value === 7 ? '2' : '1'}. Runde</h6>
        </div>
      </div>

      <div>{GetMessagesForState()}</div>

      {demoState.value < 7 && (
        <div className="mt-4">
          <GameSlider onValueChange={setUserInput} />
        </div>
      )}
    </PageWrapper>
  );
};

const GetMessagesForState = () => {
  if (demoState.value < 4 && userAnswer.value > 0) {
    return (
      <>
        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Tak for dit svar!</span> Lige om lidt stiller jeg ud til Stephania, så vi kan få et resultat.
          </p>
        </MessageBox>

        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Vidste du?</span> Danskerne køber i gennemsnit 7kg slik om året - det er en tredobling på 30 år.
          </p>
        </MessageBox>
      </>
    );
  }

  if (demoState.value === 1) {
    return (
      <>
        <MessageBox>
          <p className="text-black">Første spørgsmål kommer her:</p>
        </MessageBox>

        <MessageBox>
          <p className="text-black">Hvor mange godkendte poser bolsjer kan Stephania lave på 15 minutter?</p>
        </MessageBox>
      </>
    );
  }

  if (demoState.value === 2) {
    return (
      <>
        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Skynd dig!</span> Spørgsmålet lukker snart.
          </p>
        </MessageBox>

        <MessageBox>
          <p className="text-black">Hvor mange godkendte poser bolsjer kan Stephania lave på 15 minutter?</p>
        </MessageBox>
      </>
    );
  }

  if (demoState.value === 3) {
    return (
      <>
        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Tiden er udløbet!</span> Jeg kan se du ikke nåede at svare, men du kan sagtens vinde præmien, hvis du svarer i en anden runde.
          </p>
        </MessageBox>
      </>
    );
  }

  if (demoState.value === 4) {
    return (
      <>
        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Deltager svarer:</span> 110 poser.
          </p>
        </MessageBox>

        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Vidste du?</span> Danskerne køber i gennemsnit 7kg slik om året - det er en tredobling på 30 år.
          </p>
        </MessageBox>
      </>
    );
  }

  if (demoState.value === 5) {
    return (
      <>
        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Det rigtige svar er:</span> 220 poser.
          </p>
        </MessageBox>

        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Vidste du?</span> Danskerne køber i gennemsnit 7kg slik om året - det er en tredobling på 30 år.
          </p>
        </MessageBox>
      </>
    );
  }

  if (demoState.value === 6) {
    return (
      <>
        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Danmark svarer:</span> 175 poser.
          </p>
        </MessageBox>

        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Tillykke!</span> Danmark vinder og er tættest på det rigtige svar og tager penge med videre.
          </p>
        </MessageBox>
      </>
    );
  }

  if (demoState.value === 7) {
    return (
      <>
        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Pheew det var spændende!</span> Vær klar på tasterne, inden længe kommer spørgsmål 2.
          </p>
        </MessageBox>

        <MessageBox>
          <p className="text-black">
            <span className="font-bold">Vidste du?</span> Danskerne køber i gennemsnit 7kg slik om året - det er en tredobling på 30 år.
          </p>
        </MessageBox>
      </>
    );
  }
};
